/// <reference path="appbase.ts" />

namespace TerminalApp {
    export let Voices: { [lang: string]: SpeechSynthesisVoice } = {};
    export async function Talk(text: string, delay: number = 0, cancelFirst: boolean = false) {


        if (!App_Settings.userSettings.voice_assistance) 
            return;
        

        InitializeVoices();

        if (delay) await SP.sleep(delay);

        let v = new SpeechSynthesisUtterance(text);
        var voice = TerminalApp.Voices[App_Settings.userSettings.voice_language];
        if (voice) {
            v.voice = voice;
            v.lang = voice.lang;
            v.volume = 1;
        }
        v.rate = App_Settings.userSettings.voice_speed;

        if (cancelFirst) window.speechSynthesis.cancel();
        window.speechSynthesis.speak(v);
    }

    export function InitializeVoices(force:boolean = false) {
        if (force || (!Voices || Object.keys(Voices).length == 0)) {
            //load from browser
            var varr = window.speechSynthesis.getVoices();
            if (varr && varr.length) {
                for (let i = 0; i < varr.length; i++) {
                    let key = varr[i].lang.replace('_', '-');
                    Voices[key] = varr[i];
                }
            }

            document.getElementById("s_voice_language").innerHTML = "";

            for (var lang in Voices) {
                let v = Voices[lang];
                let opt = document.getElementById("s_voice_language").appendChild(document.createElement("option"));
                opt.value = lang;
                opt.innerHTML = lang + " - " + v.name;
            }
            window.speechSynthesis.cancel();
            window.speechSynthesis.resume();
            window.speechSynthesis.cancel();
            window.speechSynthesis.resume();
            window.speechSynthesis.cancel();
            window.speechSynthesis.resume();

            if (force) {
                Talk("ok");
            }

            (document.getElementById("s_voice_language") as HTMLInputElement).value = App_Settings.userSettings.voice_language.toString();
        }
    }

    export class App_Settings extends AppBase {
        static instance: App_Settings;

        static wmsSettings = {
            allow_soft_barcode_match: (window as any)._wmsSettings.allow_soft_barcode_match,
            autoprint_pallet_label: (window as any)._wmsSettings.autoprint_pallet_label,
            use_additional_placement_barcodes: (window as any)._wmsSettings.use_additional_placement_barcodes,
            move_all_placement: (window as any)._wmsSettings.move_all_placement,
            fulfillment_location: (window as any)._wmsSettings.fulfillment_location,
        }

        static userSettings = {
            interface_zoom: 0.7,
            terminal_langauge: "DK",
            finish_package_delay: 5,
            voice_assistance: true,
            voice_index: -1,
            voice_language: "da-DK",
            voice_speed: 1.3,
            voice_delay: 300,
            voice_arrival_confirm_quantity: true,
            voice_picklist_read_placement: true,
            voice_picklist_read_quantity: true,
            voice_picklist_read_tote: true,
            voice_picklist_confirm_tote_finish: true,
            auto_double_scan_picking: true,
            auto_double_scan_stocking: true,
            auto_double_scan_moving: true,
            auto_double_scan_print_label: true,
            auto_print_shipping_label: true,
            autogenerate_production_batch_number: true,
            allow_mixed_arrival: false,
            allow_split_delivery: true,
            allow_autofill_package: true,
            hide_empty_pick_profiles: false,
            print_delivery_instantly: false
        }

        static terminalSettings = {
            transport: 0,
            barcode_prefix: '{',
            barcode_surfix: '}',
            etiquette_printer: '',
            label_printer: '',
            a4_printer: '',
            tote_sorting: "name"
        }

        static userRights = {
            refund: true,
        }

        userId: string = "";

        //inputs
        input_interface_zoom = document.getElementById("s_interface_zoom") as HTMLInputElement;
        input_terminal_language = document.getElementById("s_terminal_language") as HTMLInputElement;
        input_finish_package_delay = document.getElementById("s_finish_package_delay") as HTMLInputElement;
        input_tote_sorting = document.getElementById("s_tote_sorting") as HTMLInputElement;
        input_auto_double_scan_stocking = new SP.CheckboxDoodle(document.getElementById("s_auto_double_scan_stocking") as HTMLInputElement);
        input_auto_double_scan_picking = new SP.CheckboxDoodle(document.getElementById("s_auto_double_scan_picking") as HTMLInputElement);
        input_auto_double_scan_moving = new SP.CheckboxDoodle(document.getElementById("s_auto_double_scan_moving") as HTMLInputElement);
        input_auto_double_scan_print_label = new SP.CheckboxDoodle(document.getElementById("s_auto_double_scan_print_label") as HTMLInputElement);
        input_auto_print_shipping_label = new SP.CheckboxDoodle(document.getElementById("s_auto_print_shipping_label") as HTMLInputElement); 
        input_print_delivery_instantly = new SP.CheckboxDoodle(document.getElementById("s_print_delivery_instantly") as HTMLInputElement);
        input_autogenerate_production_batch_number = new SP.CheckboxDoodle(document.getElementById("s_autogenerate_production_batch_number") as HTMLInputElement);
        input_allow_mixed_arrival = new SP.CheckboxDoodle(document.getElementById("s_allow_mixed_arrival") as HTMLInputElement); 
        input_voice_assistance = new SP.CheckboxDoodle(document.getElementById("s_voice_assistance") as HTMLInputElement);
        input_allow_split_delivery = new SP.CheckboxDoodle(document.getElementById("s_allow_split_delivery") as HTMLInputElement);
        input_allow_autofill_package = new SP.CheckboxDoodle(document.getElementById("s_allow_autofill_package") as HTMLInputElement);
        input_hide_empty_pick_profiles = new SP.CheckboxDoodle(document.getElementById("s_hide_empty_pick_profiles") as HTMLInputElement);
        input_voice_language = document.getElementById("s_voice_language") as HTMLInputElement;
        input_voice_speed = document.getElementById("s_voice_speed") as HTMLInputElement;
        input_voice_delay = document.getElementById("s_voice_delay") as HTMLInputElement;
        input_voice_arrival_confrim_quantity = new SP.CheckboxDoodle(document.getElementById("s_voice_arrival_confirm_quantity") as HTMLInputElement);
        input_voice_picklist_read_placement = new SP.CheckboxDoodle(document.getElementById("s_voice_picklist_read_placement") as HTMLInputElement);
        input_voice_picklist_read_quantity = new SP.CheckboxDoodle(document.getElementById("s_voice_picklist_read_quantity") as HTMLInputElement);
        input_voice_picklist_read_tote = new SP.CheckboxDoodle(document.getElementById("s_voice_picklist_read_tote") as HTMLInputElement);
        input_voice_picklist_confirm_tote_finished = new SP.CheckboxDoodle(document.getElementById("s_voice_picklist_confirm_tote_finished") as HTMLInputElement);

        

        input_barcode_prefix = document.getElementById("s_barcode_prefix") as HTMLInputElement;
        input_barcode_surfix = document.getElementById("s_barcode_surfix") as HTMLInputElement;


        voice_settings = document.getElementById("voice_settings");
        input_etiquette_printer = document.getElementById("s_etiquette_printer") as HTMLSelectElement;
        input_label_printer = document.getElementById("s_label_printer") as HTMLSelectElement;
        input_a4_printer = document.getElementById("s_a4_printer") as HTMLSelectElement;
        s_test_connection = document.getElementById("s_test_connection");
        input_transport = document.getElementById("s_transport") as HTMLSelectElement;
        s_device_log = document.getElementById("s_device_log");
        s_location_mapping = document.getElementById("s_location_mapping");
        constructor() {
            super("app_settings");
            App_Settings.instance = this;
            this.userId = (document.getElementById("settings_user_id") as HTMLInputElement).value;
            this.initializeInputs();

            this.s_test_connection.addEventListener("click", () => {
                GetApp("app_status").open();
            });

            this.s_device_log.addEventListener("click", () => {
                GetApp("app_device_log").open();
            });

            this.s_location_mapping.addEventListener("click", () => {
                GetApp("app_location_mapping").open();
            });

            this.loadTerminalSettings();
        }

        async onOpen() {
            InitializeVoices();
        }

        initializeInputs() {
            InitializeVoices();
            this.input_interface_zoom.addEventListener("change", () => {
                App_Settings.userSettings.interface_zoom = parseFloat(this.input_interface_zoom.value);
                this.saveSettings();
            });


            this.input_terminal_language.addEventListener("change",async () => {
                App_Settings.userSettings.terminal_langauge = this.input_terminal_language.value;
                this.saveSettings();
            });

            this.input_finish_package_delay.addEventListener("change", async () => {
                App_Settings.userSettings.finish_package_delay = parseInt(this.input_finish_package_delay.value);
                this.saveSettings();
            });



            this.input_auto_double_scan_stocking.onChange = () => {
                App_Settings.userSettings.auto_double_scan_stocking = this.input_auto_double_scan_stocking.checked;
                this.saveSettings();
            };

            this.input_auto_double_scan_picking.onChange = () => {
                App_Settings.userSettings.auto_double_scan_picking = this.input_auto_double_scan_picking.checked;
                this.saveSettings();
            };

            this.input_auto_double_scan_moving.onChange = () => {
                App_Settings.userSettings.auto_double_scan_moving = this.input_auto_double_scan_moving.checked;
                this.saveSettings();
            };

            this.input_auto_double_scan_print_label.onChange = () => {
                App_Settings.userSettings.auto_double_scan_print_label = this.input_auto_double_scan_print_label.checked;
                this.saveSettings();
            };


            this.input_auto_print_shipping_label.onChange = () => {
                App_Settings.userSettings.auto_print_shipping_label = this.input_auto_print_shipping_label.checked;
                this.saveSettings();
            };

            this.input_autogenerate_production_batch_number.onChange = () => {
                App_Settings.userSettings.autogenerate_production_batch_number = this.input_autogenerate_production_batch_number.checked;
                this.saveSettings();
            };

            this.input_print_delivery_instantly.onChange = () => {
                App_Settings.userSettings.print_delivery_instantly = this.input_print_delivery_instantly.checked;
                this.saveSettings();
            };

            this.input_allow_mixed_arrival.onChange = () => {
                App_Settings.userSettings.allow_mixed_arrival = this.input_allow_mixed_arrival.checked;
                this.saveSettings();
            };
            

            this.input_voice_speed.addEventListener("change", () => {
                App_Settings.userSettings.voice_speed = parseFloat(this.input_voice_speed.value);
                this.saveSettings();

                Talk(" ", 0, true);
                Talk(" ");
                Talk("test 1 2 3 456");
            });

            this.input_voice_delay.addEventListener("change", () => {
                App_Settings.userSettings.voice_delay = parseInt(this.input_voice_delay.value);
                this.saveSettings();
            });

            this.input_voice_assistance.onChange = () => {
                App_Settings.userSettings.voice_assistance = this.input_voice_assistance.checked;

                if (App_Settings.userSettings.voice_assistance) {
                    InitializeVoices(true);
                }

                this.saveSettings();
            };

            this.input_voice_arrival_confrim_quantity.onChange = () => {
                App_Settings.userSettings.voice_arrival_confirm_quantity = this.input_voice_arrival_confrim_quantity.checked;
                this.saveSettings();

                if (this.input_voice_arrival_confrim_quantity.checked)
                    Talk(parseInt((1 + Math.random() * 25).toFixed(0)).toString(), 0, true);
            };

            this.input_voice_picklist_read_placement.onChange = () => {
                App_Settings.userSettings.voice_picklist_read_placement = this.input_voice_picklist_read_placement.checked;
                this.saveSettings();

                if (this.input_voice_picklist_read_placement.checked)
                    Talk("B3, 2 3", 0, true);
            };

            this.input_voice_picklist_read_quantity.onChange = () => {
                App_Settings.userSettings.voice_picklist_read_quantity = this.input_voice_picklist_read_quantity.checked;
                this.saveSettings();
                if (this.input_voice_picklist_read_quantity.checked)
                    Talk(SP.Localize("word_pick") + " 10");
            };

            this.input_voice_picklist_read_tote.onChange = () => {
                App_Settings.userSettings.voice_picklist_read_tote = this.input_voice_picklist_read_tote.checked;
                this.saveSettings();
                if (this.input_voice_picklist_read_tote.checked)
                    Talk(SP.Localize("word_tote") + " B-5");


            };

            this.input_voice_picklist_confirm_tote_finished.onChange = () => {
                App_Settings.userSettings.voice_picklist_confirm_tote_finish = this.input_voice_picklist_confirm_tote_finished.checked;
                this.saveSettings();
                if (this.input_voice_picklist_confirm_tote_finished.checked)
                    Talk(SP.Localize("sentance_tote_finished"));

            };

            this.input_voice_language.addEventListener("change", () => {
                App_Settings.userSettings.voice_language = this.input_voice_language.value;

                this.saveSettings();
                Talk(" ", 0, true);
                Talk(" ");
                Talk("test 1 2 3 456");
                
            });

            this.input_barcode_prefix.addEventListener("change", () => {
                App_Settings.terminalSettings.barcode_prefix = this.input_barcode_prefix.value ? this.input_barcode_prefix.value[0] : null;
                this.saveSettings();
            });

            this.input_barcode_surfix.addEventListener("change", () => {
                App_Settings.terminalSettings.barcode_surfix = this.input_barcode_surfix.value ? this.input_barcode_surfix.value[0] : null;
                this.saveSettings();
            });

            this.input_etiquette_printer.addEventListener("change", () => {
                App_Settings.terminalSettings.etiquette_printer = this.input_etiquette_printer.value ? this.input_etiquette_printer.value : '';
                this.saveSettings();
            });

            this.input_label_printer.addEventListener("change", () => {
                App_Settings.terminalSettings.label_printer = this.input_label_printer.value ? this.input_label_printer.value : '';
                this.saveSettings();
            });

            this.input_a4_printer.addEventListener("change", () => {
                App_Settings.terminalSettings.a4_printer = this.input_a4_printer.value ? this.input_a4_printer.value : '';
                this.saveSettings();
            });

            this.input_tote_sorting.addEventListener("change", async () => {
                App_Settings.terminalSettings.tote_sorting = this.input_tote_sorting.value;
                this.saveSettings();
            });

            this.input_transport.addEventListener("change", async () => {
                App_Settings.terminalSettings.transport = parseInt(this.input_transport.value);
                this.saveSettings();
                await SP.sleep(200);
                location.reload();
            });



            this.input_allow_split_delivery.onChange = () => {
                App_Settings.userSettings.allow_split_delivery = this.input_allow_split_delivery.checked;
                this.saveSettings();
            };

            this.input_hide_empty_pick_profiles.onChange = () => {
                App_Settings.userSettings.hide_empty_pick_profiles = this.input_hide_empty_pick_profiles.checked;
                this.saveSettings();
            };

            this.input_allow_autofill_package.onChange = () => {
                App_Settings.userSettings.allow_autofill_package = this.input_allow_autofill_package.checked;
                this.saveSettings();
            };
        }

        async loadTerminalSettings() {
            var terminalData = localStorage.getItem("terminal_settings_1");
            if (terminalData) {
                let td = JSON.parse(terminalData);
                for (var key in td) {
                    (App_Settings.terminalSettings as any)[key] = td[key];
                }
            }
            this.updateTerminalInputs();
        }


        async loadUserSettings() {
            InitializeVoices();
            
            var userData = await TerminalApp.hub.connection.invoke<any>("LoadTerminalSettings");
            if (userData) {
                let ud = JSON.parse(userData);
                for (var key in ud) {
                    (App_Settings.userSettings as any)[key] = ud[key];
                }
            }
            //force zoom
            if (App_Settings.userSettings.interface_zoom > 1) App_Settings.userSettings.interface_zoom = 1;
            this.updateUserSettingsInput();
        }

        async saveSettings() {
            await TerminalApp.hub.connection.invoke<any>("SaveTerminalSettings", JSON.stringify(App_Settings.userSettings));
            //localStorage.setItem("user_settings_1_" + this.userId, JSON.stringify(App_Settings.userSettings));
            localStorage.setItem("terminal_settings_1", JSON.stringify(App_Settings.terminalSettings));
            this.loadUserSettings();
        }

        async updateTerminalInputs() {
            this.input_barcode_prefix.value = App_Settings.terminalSettings.barcode_prefix;
            this.input_barcode_surfix.value = App_Settings.terminalSettings.barcode_surfix;

            this.input_etiquette_printer.value = App_Settings.terminalSettings.etiquette_printer;
            this.input_label_printer.value = App_Settings.terminalSettings.label_printer;
            this.input_a4_printer.value = App_Settings.terminalSettings.a4_printer;
            this.input_tote_sorting.value = App_Settings.terminalSettings.tote_sorting.toString();
            this.input_transport.value = App_Settings.terminalSettings.transport.toString();
            barcodeListener._startSymbol = App_Settings.terminalSettings.barcode_prefix ?? null;
            barcodeListener._endSymbol = App_Settings.terminalSettings.barcode_surfix ?? null;

        }

        async updateUserSettingsInput() {
            //update settings inputs
            //console.log("setting to:" + SP.zoom().toString());
            this.input_interface_zoom.value = App_Settings.userSettings.interface_zoom.toString();
            this.input_terminal_language.value = App_Settings.userSettings.terminal_langauge.toString();
            this.input_finish_package_delay.value = App_Settings.userSettings.finish_package_delay.toString();
            this.input_voice_assistance.checked = App_Settings.userSettings.voice_assistance;
            this.input_auto_double_scan_stocking.checked = App_Settings.userSettings.auto_double_scan_stocking;
            this.input_auto_double_scan_picking.checked = App_Settings.userSettings.auto_double_scan_picking;
            this.input_auto_double_scan_moving.checked = App_Settings.userSettings.auto_double_scan_moving;
            this.input_auto_double_scan_print_label.checked = App_Settings.userSettings.auto_double_scan_print_label;
            this.input_auto_print_shipping_label.checked = App_Settings.userSettings.auto_print_shipping_label;
            this.input_autogenerate_production_batch_number.checked = App_Settings.userSettings.autogenerate_production_batch_number;
            this.input_print_delivery_instantly.checked = App_Settings.userSettings.print_delivery_instantly;
            this.input_allow_mixed_arrival.checked = App_Settings.userSettings.allow_mixed_arrival;
            this.input_voice_language.value = App_Settings.userSettings.voice_language.toString();
            this.input_voice_speed.value = App_Settings.userSettings.voice_speed.toString();
            this.input_voice_delay.value = App_Settings.userSettings.voice_delay.toString();
            this.input_voice_arrival_confrim_quantity.checked = App_Settings.userSettings.voice_arrival_confirm_quantity;
            this.input_voice_picklist_read_placement.checked = App_Settings.userSettings.voice_picklist_read_placement;
            this.input_voice_picklist_read_quantity.checked = App_Settings.userSettings.voice_picklist_read_quantity;
            this.input_voice_picklist_read_tote.checked = App_Settings.userSettings.voice_picklist_read_tote;
            this.input_voice_picklist_confirm_tote_finished.checked = App_Settings.userSettings.voice_picklist_confirm_tote_finish;
            this.voice_settings.style.display = App_Settings.userSettings.voice_assistance ? "block" : "none";
            this.input_allow_split_delivery.checked = App_Settings.userSettings.allow_split_delivery;
            this.input_allow_autofill_package.checked = App_Settings.userSettings.allow_autofill_package;
            this.input_hide_empty_pick_profiles.checked = App_Settings.userSettings.hide_empty_pick_profiles;

            //update globals
            SP.zoom(App_Settings.userSettings.interface_zoom);
       
            //change langauge
            if ((window as any).Current_Language as any != App_Settings.userSettings.terminal_langauge) {
                await SP.get("/ChangeCountry?country=" + App_Settings.userSettings.terminal_langauge);
                location.reload();
                console.log("changing language:", (window as any).Current_Language, App_Settings.userSettings.terminal_langauge);
            }
        }
    }
    RegisterApp("app_settings", App_Settings);
}